import React from 'react';

interface MiniChartProps {
  data: number[];
  width?: number;
  height?: number;
  color?: string;
}

const MiniChart: React.FC<MiniChartProps> = ({ 
  data, 
  width = 60, 
  height = 20, 
  color = '#6B7280' 
}) => {
  if (!data || data.length === 0) {
    return (
      <div 
        className="flex items-center justify-center"
        style={{ width, height }}
      >
        <div className="w-full h-0.5 bg-gray-300"></div>
      </div>
    );
  }

  // Normalizar os dados para caber no gráfico
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min;
  
  // Se não há variação, mostrar linha reta
  if (range === 0) {
    return (
      <div 
        className="flex items-center justify-center"
        style={{ width, height }}
      >
        <div className="w-full h-0.5 bg-gray-300"></div>
      </div>
    );
  }

  const normalizedData = data.map(value => 
    ((value - min) / range) * (height - 4) + 2
  );

  // Criar pontos para o SVG
  const points = normalizedData.map((y, index) => {
    const x = (index / (data.length - 1)) * (width - 4) + 2;
    return `${x},${height - y}`;
  }).join(' ');

  return (
    <div style={{ width, height }} className="flex items-center">
      <svg width={width} height={height} className="overflow-visible">
        <polyline
          points={points}
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default MiniChart;
